export class Beneficiario {
  nuControle: string;
  nome: string;
  cpf: string;
  dtNascimento: string;
  cdUsuario: string;
  cdPessoa: number;
  meioAcesso: string;
  telefone: string;
  email: string;
  responseToken: any;
  cdSenha: string;
  token: string;
  cdFilial: string;
  cdTipoRede: string;
}
